import { LoadingSpinner } from './loading-spinner';

const FullPageLoadingSpinner = () => {
  return (
    <div className="fixed top-0 right-0 bottom-0 left-0">
      <LoadingSpinner className="h-full" />
    </div>
  );
};

export default FullPageLoadingSpinner;
